import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import { selectHydrated } from '../../../redux/modules/banks/selectors';

import { TYPE_MAP } from '../../Registration/CompanyForm/Addresses';


class Company extends PureComponent {
  static propTypes = {
    banks: PropTypes.array,
    company: PropTypes.object
  };

  render() {
    const {
      fullName,
      registrationNumber,
      vatNumber,
      prePaid,
      addresses,
      accounts
    } = this.props;

    return (
      <div className="container mt-5">
        <h1>Uzņēmums</h1>
        
        <table className="table mt-5">
          <colgroup><col style={{width: "30%"}}/></colgroup>
          <thead className="thead-default">
            <tr><th colSpan="2">Pamatinformācija</th></tr>
          </thead>
          <tbody>
            <tr><th>Nosaukums</th><td>{fullName}</td></tr>
            <tr><th>Reģistrācijas numurs</th><td>{registrationNumber}</td></tr>
            <tr><th>PVN numurs</th><td>{vatNumber}</td></tr>
            <tr><th>Apmaksa</th><td>{prePaid  
              ? <span>Priekšapmaksa</span>
              : <span>Pēcapmaksa</span>
            }</td></tr>
          </tbody>
        </table>

        { addresses.length > 0  && (
          <table className="table">
            <colgroup><col style={{width: "30%"}}/></colgroup>
            <thead className="thead-default">
                <tr><th colSpan="2">Adrese</th></tr>
            </thead>
            <tbody>
              { addresses.map(({address, type}, i) => 
                <tr key={i}>
                  <th>{TYPE_MAP[type]}</th><td>{address}</td>
                </tr>
              )}
            </tbody>
          </table>
        ) }

        { accounts.length > 0  && (
          <table className="table">
            <colgroup><col style={{width: "30%"}}/></colgroup>
            <thead className="thead-default">
                <tr><th colSpan="2">Bankas konti</th></tr>
            </thead>
            <tbody>
              { accounts.map(({bank, number}, i) => 
                <tr key={i}>
                  <th>{bank.name}</th><td>{number}</td>
                </tr>
              )}
            </tbody>
          </table>
        ) }
      </div>
    )
  }
}

const mapStateToProps = (state, {accounts, ...props}) => ({
  ...props,
  accounts: accounts.map(({ bank, number }) => ({
    bank: selectHydrated(state, bank),
    number
  }))
});

const ConnectedCompany = connect(mapStateToProps)(Company);

// @TODO LOADER?
const WrappedCompany = (props, {company}) => company? <ConnectedCompany {...company} /> : null; 

WrappedCompany.contextTypes = {
  company: PropTypes.object
};

export default WrappedCompany;


// WEBPACK FOOTER //
// ./src/scenes/Profile/Company/index.js